import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { getSummaryScreen, iThirdPartyFormValues } from '@services/ThirdPartyService';
import { Summary } from '@components';

function TPStep5(): ReactElement {
  const { values }: { values: iThirdPartyFormValues } = useFormikContext();
  return (
    <div>
      <Summary summaryFields={getSummaryScreen(values)} />
    </div>
  );
}

export default TPStep5;
